import "./ExpandedAreaPrediction.css";
import Spacer from "../Spacer/Spacer";
import React from "react";

const ExpandedAreaPrediction = (props) => {
    let column_map = {
        "GKP": ["points_clean_sheet", "points_saves", "points_pen_saves", "points_goals", "points_penalty_goals", "points_assists", "points_minutes", "points_starts", "points_negative", "points_bps"],
        "DEF": ["points_goals", "points_penalty_goals", "points_assists", "points_clean_sheet", "points_defcon", "points_minutes", "points_starts", "points_negative", "points_bps"],
        "MID": ["points_goals", "points_penalty_goals", "points_assists", "points_clean_sheet", "points_defcon", "points_minutes", "points_starts", "points_negative", "points_bps"],
        "FWD": ["points_goals", "points_penalty_goals", "points_assists", "points_defcon", "points_minutes", "points_starts", "points_negative", "points_bps"]
    }

    let columns_without_multiplier = ["points_bps", "points_negative", "points_starts"]

    let column_name_map = {
        "points_goals": "goals",
        "points_penalty_goals": "penalty goals",
        "points_assists": "assists",
        "points_clean_sheet": "clean sheet",
        "points_defcon": "DEFCON",
        "points_goals_conceded": "2 goals against",
        "points_bps": "Bonus",
        "points_minutes": "60 Minutes",
        "points_starts": "Starts",
        "points_saves": "Saves (3x)",
        "points_pen_saves": "Penalty Saves",
        "points_negative": "Negatives"
    }

    let column_format_map = {
        "points_goals": "number",
        "points_penalty_goals": "number",
        "points_assists": "number",
        "points_clean_sheet": "%",
        "points_defcon": "%",
        "points_goals_conceded": "number",
        "points_bps": "number",
        "points_minutes": "%",
        "points_starts": "number",
        "points_saves": "number",
        "points_pen_saves": "number",
        "points_negative": "number"
    }

    let column_points_map = {
        "points_goals": {"GKP": 10, "DEF": 6, "MID": 5, "FWD": 4},
        "points_penalty_goals": {"GKP": 10, "DEF": 6, "MID": 5, "FWD": 4},
        "points_assists": {"GKP": 3, "DEF": 3, "MID": 3, "FWD": 3},
        "points_clean_sheet": {"GKP": 4, "DEF": 4, "MID": 1, "FWD": 0},
        "points_defcon": {"GKP": 0, "DEF": 2, "MID": 2, "FWD": 2},
        "points_goals_conceded": {"GKP": -1, "DEF": -1, "MID": 0, "FWD": 0},
        "points_minutes": {"GKP": 1, "DEF": 1, "MID": 1, "FWD": 1},
        "points_starts": {"GKP": 1, "DEF": 1, "MID": 1, "FWD": 1},
        "points_saves": {"GKP": 1, "DEF": 0, "MID": 0, "FWD": 0},
        "points_pen_saves": {"GKP": 5, "DEF": 0, "MID": 0, "FWD": 0},
        "points_negative": {"GKP": 1, "DEF": 1, "MID": 1, "FWD": 1},
        "points_bps": {"GKP": 1, "DEF": 1, "MID": 1, "FWD": 1},
    }

     const numberFormatting = (value, format) => {
        // Over several gameweeks chances add up to expected counts, so they aren't shown as %
        if (format === "number" || props.data.multi_gw) {
            return value.toFixed(2)
        }
        if (format === "%") {
            return (value*100).toFixed(0).toString() + "%"
        }
    };

    const columnTotal = (column) => (props.data[column] || []).reduce((sum, val) => sum + (val || 0), 0);

    // Penalty goals are predicted separately from open-play goals, but only
    // players on penalties have a value, so the row is dropped for everyone else.
    const active_cols = column_map[props.data['player_position']]
        .filter((column) => column !== "points_penalty_goals" || columnTotal(column) > 0);

    const halfExpandedArea = (data) => {
        return <div className="prediction-expanded-area-half noSelect">
                <div className="expanded-area-half-container noSelect">
                    <div className="expanded-area-top-wrapper noSelect">
                        <div className="prediction-expanded-area-table-row">
                            <div className="expanded-area-table-sub-title evaluation-table-left-align">
                                Points Breakdown
                            </div>
                            <div className="expanded-area-table-column-title evaluation-table-left-align">

                            </div>
                            <div className="expanded-area-table-column-title evaluation-table-right-align">

                            </div>
                            <div className="expanded-area-table-column-title evaluation-table-right-align">

                            </div>
                        </div>

                        <div>
                            {active_cols.map((column, col_idx) => {
                                return (
                                    <div className="prediction-expanded-area-table-row" key={col_idx}>
                                        <div
                                            className="prediction-expanded-area-table-row-title prediction-table-left-align">
                                            {column_name_map[column]}
                                        </div>
                                        <div
                                            className="prediction-expanded-area-table-row-item prediction-table-right-align">
                                            {columns_without_multiplier.includes(column) ? "" :
                                                props.data[column].length === 1
                                                    ? numberFormatting(props.data[column][0] / column_points_map[column][data["player_position"]],
                                                        column_format_map[column])
                                                    : `(${props.data[column].map(val =>
                                                        numberFormatting(val / column_points_map[column][data["player_position"]],
                                                            column_format_map[column])
                                                    ).join(' + ')})`
                                            }
                                        </div>
                                        <div
                                            className="prediction-expanded-area-table-row-small-item prediction-table-right-align"
                                            style={{fontSize: "11px"}}>
                                            {columns_without_multiplier.includes(column) ? "" : "x"}
                                        </div>
                                        <div
                                            className="prediction-expanded-area-table-row-small-item prediction-table-right-align"
                                            style={{fontSize: "11px"}}>
                                            {columns_without_multiplier.includes(column) ? "" : `${column_points_map[column][data["player_position"]]}`}

                                        </div>
                                        <div
                                            className="prediction-expanded-area-table-row-small-item prediction-table-right-align"
                                            style={{fontSize: "11px"}}>
                                            {columns_without_multiplier.includes(column) ? "" : "="}
                                        </div>
                                        <div
                                            className="prediction-expanded-area-table-row-item prediction-table-right-align">
                                            {props.data[column].reduce((sum, val) => sum + val, 0).toFixed(2)}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        <div className="prediction-expanded-area-table-row total">
                            <div
                                className="prediction-expanded-area-table-row-title prediction-table-left-align">Total</div>
                            <div
                                className="prediction-expanded-area-table-row-item prediction-table-right-align"></div>
                            <div className="prediction-expanded-area-table-row-small-item prediction-table-right-align"></div>
                            <div className="prediction-expanded-area-table-row-small-item prediction-table-right-align"></div>
                            <div className="prediction-expanded-area-table-row-small-item prediction-table-right-align"></div>
                            <div className="prediction-expanded-area-table-row-item" style={{textAlign: "right"}}>
                                {Number(props.data.pred).toFixed(2)}
                            </div>
                        </div>

                        <Spacer style={{marginBottom: "12px"}}/>
                    </div>
                </div>
        </div>
    }

    const playerIdentification = () => {
        const handleImageError = (e) => {
            e.target.onerror = null; // Prevents infinite loop if placeholder also fails
            e.target.src = "https://resources.premierleague.com/premierleague25/photos/players/110x140/placeholder.png";
        };
        return (
            <div className={"left"}>
                <div className="player-identification">
                    <div className="player-identification-photo">
                        <img
                            src={`https://resources.premierleague.com/premierleague25/photos/players/110x140/${props.data.player_id}.png`}
                            height={70} width={55} alt={props.data.playerName} onError={handleImageError}
                        />
                    </div>
                </div>
                <div className="player-identification-meta">
                    <span>{props.data.player_position}</span>
                    <span className="price">£{props.data.price}m</span>
                    <span>{props.data.team_name}</span>
                </div>
            </div>
        )
    }

    const expandedAreaPrediction = (
        <div>
            <div className={"expanded-area-container"}>
                {playerIdentification()}
                <hr className={"divider"}/>
                {halfExpandedArea(props.data)}
            </div>

        </div>
    );

    return expandedAreaPrediction;
}

export default ExpandedAreaPrediction;